// src/components/FullPageLoader.jsx
import React from "react";
import Lottie from "lottie-react";
import loadingAnimation from "../../assets/images/Sandy_Loading.json";

const FullPageLoader = () => {
  return (
    <div className="fixed inset-0 z-50 bg-white/70 backdrop-blur-sm flex items-center justify-center">
      <div className="w-36 h-36">
        <Lottie animationData={loadingAnimation} loop autoplay />
      </div>
    </div>
  );
};

export default FullPageLoader;
